<template>
  <adminTable
    :hideSeachButton="true"
    :hideResetButton="true"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:query-button-right>
      <el-button type="primary" icon="CirclePlus" @click="editItem('add', {})" v-permission>添加</el-button>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="title" label="等级名称" width="130" />
      <!-- <el-table-column prop="lv0" label="全部人数" width="130" /> -->
      <el-table-column prop="lv1" label="直推人数" width="130" />
      <el-table-column prop="lv2" label="间推人数" width="130" />
      <el-table-column prop="amount" label="固定工资" width="130" />
      <el-table-column prop="team_id" label="团队等级" width="130">
        <template #default="scope"> {{ getTeamLevelName(scope.row.team_id) }} </template>
      </el-table-column>
      <el-table-column prop="level_id" label="会员等级" width="130">
        <template #default="scope"> {{ getUserLevelName(scope.row.level_id) }} </template>
      </el-table-column>
      <el-table-column prop="profit" label="团队盈利" width="130" />
      <el-table-column prop="profit_rate" label="盈利奖励（%）" width="130" />
      <el-table-column prop="sign_amount" label="签到金额" width="130" />
      <el-table-column prop="create_at" label="创建时间" width="130" />
      <el-table-column prop="update_at" label="更新时间" width="130" />

      <el-table-column label="操作" fixed="right" width="200" v-if="currentUser.role == 0">
        <template #default="scope">
          <el-button type="primary" icon="Edit" v-permission @click="editItem('edit', scope.row)">编辑</el-button>
          <el-button type="danger" icon="Delete" v-permission @click="deleteAction(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="编辑/新增" width="1100">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
  import { ref, getCurrentInstance, onMounted } from 'vue'
  import editPop from './components/teamLevel/editPop.vue'
  import { ElMessage, ElMessageBox } from 'element-plus'
  import teamLevelListHook from '@/hooks/teamLevelListHook'
  import userLevelListHook from '@/hooks/userLevelListHook'

  const dialogFlag = ref(false)
  const editFormRef = ref(false)
  const editRow = ref({})
  const formType = ref('add')

  const { levelTypeEnums, getUserLevelName } = userLevelListHook()
  const { teamLevelTypeEnums, getTeamLevelName } = teamLevelListHook()

  onMounted(() => {
    getList()
  })

  const currentUser = JSON.parse(sessionStorage.getItem('currentUser'))
  const { proxy } = getCurrentInstance()

  const page = ref(1)
  const limit = ref(10)
  const totalList = ref(0)
  const tableLoading = ref(false)
  const tableData = ref([])
  const getList = async () => {
    tableLoading.value = true
    const res = await proxy.$http({
      type: 'get',
      url: '/Team/getTeamLists',
      params: {
        page: page.value,
        limit: limit.value,
      },
    })
    tableLoading.value = false
    if (res.code == 0) {
      tableData.value = res.data.data
      totalList.value = res.data.total
    }
  }

  const editItem = (type, row) => {
    formType.value = type
    editRow.value = row
    dialogFlag.value = true
  }

  const deleteAction = (row) => {
    ElMessageBox.confirm('是否删除?', 'Warning', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(async () => {
        const res = await proxy.$http({
          method: 'get',
          url: '/Team/deleteTeam?id=' + row.id,
        })
        if (res.code == 0) {
          getList()
        }
        ElMessage({
          type: 'success',
          message: res.msg,
        })
      })
      .catch(() => {
        ElMessage({
          type: 'info',
          message: '取消删除',
        })
      })
  }

  const submitForm = async () => {
    const url = formType.value == 'add' ? 'Team/addTeam' : 'Team/updateTeam'
    const data = editFormRef.value.form
    if (formType.value == 'add') {
      data.id = null
    }
    const res = await proxy.$http({
      method: 'post',
      url: url,
      data: {
        title: data.title,
        // lv0: data.lv0,
        lv1: data.lv1,
        lv2: data.lv2,
        profit: data.profit,
        profit_rate: data.profit_rate,
        level_id: data.level_id,
        team_id: data.team_id,
        amount: data.amount,
        sign_amount: data.sign_amount,
        id: data.id,
      },
    })

    if (res.code == 0) {
      dialogFlag.value = false
      getList()
      ElMessage({
        type: 'success',
        message: res.msg,
      })
    } else {
      dialogFlag.value = false
      ElMessage({
        type: 'error',
        message: res.msg,
      })
    }
  }
</script>

<style lang="less" scoped></style>
